// extracted by mini-css-extract-plugin
module.exports = {"container":"aee5b7c44e--container--DLXVw"};